controllers.controller('AssetInfoController', [
    '$scope', '$state', '$ionicLoading', 'moment',
    'config', 'constants', 'Utils', 'AssetService', 'LocaleService', 'InvestCalcService', 'UserService', 'ServerTimeService',
    function ($scope, $state, $ionicLoading, moment,
              config, Const, Utils, AssetService, LocaleService, InvestCalcService, UserService, ServerTimeService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.constants = Const;

        $scope.assetIntoRules = $scope.constants.assetIntoRules;

        $scope.asset = AssetService.collection.get({id: parseInt($state.params.assetId, 10)});

        $scope.user = UserService.get();

        $scope.clientTimezone = ServerTimeService.timeZoneOffset;

        $scope.margin = {
            ask: '',
            bid: '',
            askCurrency: '',
            bidCurrency: ''
        };

        $scope.swap = {
            long: '',
            short: '',
            longCurrency: '',
            shortCurrency: ''
        };

        $scope.leverage = '';

        if ($scope.asset) {
            $scope.margin = calcMargin();
            $scope.swap = calcSwap();
        }

        $scope.tradingTimes = function () {
            return $scope.asset
            && $scope.tradingTimesFormat ? Object.keys($scope.tradingTimesFormat) : [];
        };

        function tradingHours() {
            if ($scope.clientTimezone !== undefined) {
                var clientTime = ServerTimeService.time,
                    clientTimezone = $scope.clientTimezone,
                    times = _.assign({}, $scope.asset.tradingTimes);
                Object.keys(times).forEach(function (key) {
                    if (times[key][0][1] === '24:00') times[key][0][1] = '23:59';
                });
                $scope.tradingTimesFormat = formatTimes(clientTime, clientTimezone, times);
            }
        }

        function parseTime(time) {
            return {
                hour: time.split(':')[0],
                minute: time.split(':')[1]
            };
        }

        function createTime(serverTime, day, range, timezone) {
            var _time = parseTime(range);
            moment.prototype.toUnix = function () {
                return this.unix() + (this.utcOffset() * 60);
            };
            return moment
                .utc(serverTime)
                .weekday(day)
                .startOf('day')
                .hour(_time.hour)
                .minute(_time.minute)
                .utcOffset(timezone);
        }

        function startOfDay(momentObj) {
            return momentObj
                .clone()
                .startOf('day')
                .toUnix();
        }

        function addDay(data, day) {
            if (!data.hasOwnProperty(day)) {
                data[day] = [];
            }
        }

        function addRange(data, day, start, stop) {
            var _start = (typeof start === 'object') ? start.format('HH:mm') : start,
                _stop = (typeof stop === 'object') ? stop.format('HH:mm') : stop;
            data[day].push(_start + '-' + _stop);
        }

        function formatTimes(clientTime, clientTimezone, times) {
            var serverTime = clientTime,
                timesRes = {};

            Object.keys(times).forEach(function (day) {
                var ranges = times[day];

                ranges.forEach(function (range) {
                    var startRange = createTime(serverTime, day, range[0], 0),
                        stopRange = createTime(serverTime, day, range[1], 0),
                        newStartRange = createTime(serverTime, day, range[0], clientTimezone),
                        newStopRange = createTime(serverTime, day, range[1], clientTimezone);

                    if (startOfDay(newStartRange) < startOfDay(startRange) &&
                        startOfDay(newStopRange) < startOfDay(stopRange)) {
                        // move range to prev day
                        addDay(timesRes, newStartRange.day());
                        addRange(timesRes, newStartRange.day(), newStartRange, newStopRange);
                    } else if (startOfDay(newStartRange) < startOfDay(startRange) &&
                        startOfDay(newStopRange) === startOfDay(stopRange)) {
                        // create new range on prev day
                        addDay(timesRes, newStartRange.day());
                        addRange(timesRes, newStartRange.day(), newStartRange, '23:59');
                        if (newStopRange.format('HH:mm') !== '00:00') {
                            // create new range on today
                            addDay(timesRes, startRange.day());
                            addRange(timesRes, startRange.day(), '00:00', newStopRange);
                        }
                    } else if (startOfDay(newStartRange) > startOfDay(startRange) &&
                        startOfDay(newStopRange) > startOfDay(stopRange)) {
                        // move range to next day
                        addDay(timesRes, newStartRange.day());
                        addRange(timesRes, newStartRange.day(), newStartRange, newStopRange);
                    } else if (startOfDay(newStopRange) > startOfDay(stopRange) &&
                        startOfDay(newStartRange) === startOfDay(startRange)) {
                        // create new range on next day
                        addDay(timesRes, newStartRange.day());
                        addRange(timesRes, newStartRange.day(), newStartRange, '23:59');
                        if (newStopRange.format('HH:mm') !== '00:00') {
                            // create new range on today
                            addDay(timesRes, newStopRange.day());
                            addRange(timesRes, newStopRange.day(), '00:00', newStopRange);
                        }
                    } else {
                        // range which stays on today
                        addDay(timesRes, startRange.day());
                        addRange(timesRes, startRange.day(), newStartRange, newStopRange);
                    }

                });

            });
            return timesRes;
        }

        var marginWatch = $scope.$watchGroup(['asset.bid', 'asset.ask'], function (newVal, oldVal) {
            if (newVal && oldVal && (newVal[0] !== oldVal[0] ||  newVal[1] !== oldVal[1])) {
                $scope.margin = calcMargin();
                $scope.swap = calcSwap();
            }
        });

        function calcMargin() {
            var marginBid = InvestCalcService.calcMargin(1, 'sell', $scope.asset, $scope.user),
                marginAsk = InvestCalcService.calcMargin(1, 'buy', $scope.asset, $scope.user);

            $scope.leverage = InvestCalcService.calcLeverage($scope.asset, marginBid.requiredMargin);

            return {
                ask: marginAsk.requiredMargin,
                bid: marginBid.requiredMargin,
                askCurrency: marginAsk.baseVal,
                bidCurrency: marginBid.baseVal
            };
        }

        function calcSwap() {
            var longSwap = $scope.asset.swapsLong,
                shortSwap = $scope.asset.swapsShort,
                marginBidSwap = InvestCalcService.calcMargin(1, 'sell', $scope.asset, $scope.user, shortSwap),
                marginAskSwap = InvestCalcService.calcMargin(1, 'buy', $scope.asset, $scope.user, longSwap);

            return {
                long: longSwap,
                short: shortSwap,
                longCurrency: marginAskSwap.baseVal,
                shortCurrency: marginBidSwap.baseVal
            };
        }

        function getDescription(){
            if(!$scope.translation.assetInfo || ($scope.translation.assetInfo && !$scope.translation.assetInfo.nameMatch)){
                $scope.description = undefined;
                return
            };

            // check if we have match by name translation
            var singleMatch = function(match){
                var re = new RegExp(match.pattern);
                if (re.test($scope.asset.s)) {
                    return match.text;
                }
            };

            $scope.description = $scope.translation.assetInfo.nameMatch.reduce(function(acc, cur){
                return singleMatch(cur) || acc;
            }, '');

        };

        $scope.$on('$ionicView.beforeEnter', function () {
            tradingHours();
            getDescription();
        });

        $scope.$on('clear', function () {
            log('clear asset info controller');
            marginWatch();
        });

    }]);
